import {Grid} from '@mantine/core';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import * as Colors from 'ui-library/Colors';

import {Grid as GridType} from './DataLayoutTypes';
import GridBlock, {gridBlockStyles} from './GridBlock';

interface GridSectionProps {
  grid: GridType;
  layoutPath: Array<string | number>;
  isInCombinedBlock?: boolean;
}

/** @package */
export default function GridSection({
  grid,
  layoutPath,
  isInCombinedBlock = false,
}: GridSectionProps): JSX.Element {
  const isCurrentBlockCombined = grid.gridConfig?.combineBlocks || isInCombinedBlock;
  return (
    <Grid
      className={css(
        grid.gridConfig?.combineBlocks && styles.combinedBlock,
        grid.gridConfig?.combineBlocks && gridBlockStyles.blockBorder
      )}
    >
      {grid.rows
        .map((row, rowIndex) =>
          row.map((block, columnIndex) => (
            <Grid.Col span={12 / row.length} key={`block-${rowIndex}-${columnIndex}`}>
              {block.type === 'NESTED_GRID' ? (
                <GridSection
                  grid={block}
                  layoutPath={[...layoutPath, 'rows', rowIndex, columnIndex]}
                  isInCombinedBlock={block.gridConfig?.combineBlocks || isCurrentBlockCombined}
                />
              ) : (
                <GridBlock
                  block={block}
                  key={`block-${rowIndex}-${columnIndex}`}
                  layoutPath={[...layoutPath, 'rows', rowIndex, columnIndex]}
                  hasBorder={!isCurrentBlockCombined}
                />
              )}
            </Grid.Col>
          ))
        )
        .flat()}
    </Grid>
  );
}

const styles = StyleSheet.create({
  combinedBlock: {
    backgroundColor: Colors.WHITE,
    borderRadius: '4px',
  },
});
